import React from "react";
import PropTypes from "prop-types";
import { FilterDatePicker } from "@td/ui";
import { translate } from "@td/shared_utils";

const ConsultDateFilter = React.memo((props) => (
  <FilterDatePicker
    {...props}
    selectsRange
    label={translate(null, "care_team_tasks.filters.fields.consult_date", "label")}
    placeholder={translate(null, "care_team_tasks.filters.fields.consult_date", "placeholder")}
  />
));

ConsultDateFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

ConsultDateFilter.displayName = "ConsultDateFilter";

export default ConsultDateFilter;
